
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/rvu",
      function () {
        return require("private-next-pages/projects/rvu/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/rvu"])
      });
    }
  